import { getJSON } from 'redux-api-middleware';

import apiService from 'src/services/api-service';
import {
  CHANGE_SEMANTIC_FAILURE,
  CHANGE_SEMANTIC_REQUEST,
  CHANGE_SEMANTIC_SUCCESS,
  GET_SEMANTIC_FAILURE,
  GET_SEMANTIC_REQUEST,
  GET_SEMANTIC_SUCCESS,
  STOP_TRIGGER_SYNC_SEMANTIC,
  TRIGGER_SYNC_SEMANTIC
} from 'stores/flow-type/semantic.type';
import { processRes } from 'src/helpers/actions-helper';
import { showSABToast } from 'src/integrations/shopify-app-bridge/toast';

const getSetting = data => {
  const { settings = {} } = data;
  return {
    available: settings.available,
    enable: settings.enable,
    weight: settings.weight
  };
};

export const getSemanticSettings = (i18n, isCheckSync) => {
  return apiService.sendRequest('admin-v3.semantic.get-semantic', {}, [
    GET_SEMANTIC_REQUEST,
    {
      type: GET_SEMANTIC_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);
        const settings = getSetting(data);
        if (isCheckSync && settings.enable) {
          const message = i18n.translate('AdminHTML.SemanticSearch.Actions.syncSuccess');
          await showSABToast(message, 'info', 45000);
        }
        return { settings };
      }
    },
    {
      type: GET_SEMANTIC_FAILURE,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    }
  ]);
};

export const changeSemanticSettings = (data: { weight: string, enable: boolean }, meta, i18n) => {
  return apiService.sendRequest('admin-v3.semantic.change-semantic-setting', { body: data }, [
    CHANGE_SEMANTIC_REQUEST,
    {
      type: CHANGE_SEMANTIC_SUCCESS,
      payload: async (action, state, res) => {
        const message = i18n.translate('AdminHTML.SemanticSearch.Actions.updateSettings_Success');
        const data = await processRes(res, 'info', message, i18n);
        return { settings: getSetting(data) };
      },
      meta
    },
    {
      type: CHANGE_SEMANTIC_FAILURE,
      payload: async (action, state, res) => {
        return await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.SemanticSearch.Actions.updateSettings_Failure'),
          i18n
        );
      },
      meta
    }
  ]);
};

export const triggerCheckSyncSemantic = () => ({
  type: TRIGGER_SYNC_SEMANTIC
});

export const stopTriggerCheckSyncSemantic = () => ({
  type: STOP_TRIGGER_SYNC_SEMANTIC
});
